import { Modal } from '@/components/ui/modal';
import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';
import { ReactNode } from 'react';
import { Typography } from '@/components/ui/typography';

type ConfirmDeleteDialogProps = {
  show: boolean;
  title: string | ReactNode;
  message: string;
  confirmButtonText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
};

const ConfirmDeleteDialog = ({
  show,
  title,
  message,
  confirmButtonText = 'Remove',
  onConfirm,
  onCancel,
  isLoading = false
}: ConfirmDeleteDialogProps) => (
  <Modal
    open={show}
    onOpenChange={(open) => !open && onCancel()}
    title={title}
    size="md"
  >
    <div className="flex flex-col gap-3 p-3">
      <Typography as="p" variant="body">
        {message}
      </Typography>
      <div className="flex flex-col-reverse gap-2 sm:flex-row sm:items-center sm:justify-end">
        <Button
          type="button"
          variant="outline"
          onClick={onCancel}
          disabled={isLoading}
          className="w-full sm:w-auto"
        >
          Cancel
        </Button>
        <Button
          type="button"
          variant="destructive"
          onClick={onConfirm}
          disabled={isLoading}
          className="w-full sm:w-auto"
        >
          {isLoading && <Loader2 className="h-4 w-4 animate-spin" />}
          {confirmButtonText}
        </Button>
      </div>
    </div>
  </Modal>
);

export default ConfirmDeleteDialog;
